import packagesListTitle0 from './packages-list-title0.png'
import packagesListTitle1 from './packages-list-title1.png'
import packagesListTitle2 from './packages-list-title2.png'
import a0 from './a0.png'
import a1 from './a1.png'
import a2 from './a2.png'
import b0 from './b0.png'
import b1 from './b1.png'
import b2 from './b2.png'
import add from './add.png'
import logo from './logo.png'
let packagesListTitle = [
    packagesListTitle0,
    packagesListTitle1,
    packagesListTitle2
]
let codeList = [
    [
        a0,
        b0
    ],
    [
        a1,
        b1
    ],
    [
        a2,
        b2
    ]
]
export {
    packagesListTitle as packagesListTitle,
    logo as logo,
    add as add,
    codeList as codeList
}